import React from 'react';
import block from 'bem-cn';
import { useSelector } from 'react-redux';

import PaginatorSwitcher from 'components/Paginator/PaginatorSwitcher/desktop';

import useCashbackList from '../../../../model/useCashbackList';
import CashbackListItem from './CashbackListItem';

import './CashbackList.scss';

const b = block('cashback-list-desktop');

const CashbackList = () => {
  const locale = useSelector(s => s.locale.locale);
  const { values, handlers } = useCashbackList();

  const headers = [locale.players, locale.conditions, locale.amount, locale.date, locale.result, locale.actions].map(
    (t, i) => (
      <div className={b('table-cell')} key={i}>
        {t}
      </div>
    ),
  );

  const items = (values.items || []).map(item => (
    <CashbackListItem item={item} key={item.id} onDelete={handlers.handleDelete} />
  ));

  return (
    <article className={b()}>
      <section className={b('table')}>
        <div className={b('table-header')}>{headers}</div>
        <div className={b('table-body')}>
          {items.length > 0 ? items : <div className={b('empty')}>{locale.noResultsFound}</div>}
        </div>
      </section>

      {values.count > 0 && (
        <div className={b('paginator-wrapper')}>
          <div className={b('extra')}>
            <div className={b('extra-info')}>
              {values.count} {locale.records}
            </div>
          </div>
          <PaginatorSwitcher
            count={values.count}
            currentPage={values.state.page}
            onPageClick={handlers.handlePageChange}
            itemsOnPage={{ value: values.activeItemsOnPage }}
          />
        </div>
      )}
    </article>
  );
};

export default CashbackList;
